export default __webpack_public_path__ + "static/summer_containers38-0394ad553cef9b542554035a5112bb5c.webp";